"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactTimedDeletion = void 0;
const toolbox_1 = require("@streem/toolbox");
const operators_1 = require("rxjs/operators");
const logger_1 = require("../logger");
const take_first_emitted_1 = require("./take_first_emitted");
function artifactTimedDeletion(artifactId, artifacts, timeoutMs = 10000) {
    return __awaiter(this, void 0, void 0, function* () {
        (0, toolbox_1.invariant)(timeoutMs > 0, 'Timeout must be greater than 0ms');
        yield (0, take_first_emitted_1.takeFirstEmitted)(artifacts.pipe((0, operators_1.filter)(current => current.every(cur => cur.id !== artifactId)), (0, operators_1.tap)(() => logger_1.logger.info(`Artifact ${artifactId} has been deleted`)), (0, operators_1.timeout)(timeoutMs), (0, operators_1.take)(1)));
    });
}
exports.artifactTimedDeletion = artifactTimedDeletion;
//# sourceMappingURL=artifact_timed_deletion.js.map